import { useEffect, useState, useContext } from "react";
import { Route } from "react-router-dom";

import { AppContexts } from "../../providers/";

import AppLayout from "./app-layout";

import Header from "../standard/header";
import Footer from "../standard/footer";

// import styled components
import Loading from "../common/Loading";

// Expiremental
import ViewportBox from "../ui-kit/components/viewport-box";
import LineClamp from "../ui-kit/components/line-clamp";

const tone = new Audio(
  "https://s3.us-east-2.amazonaws.com/uploads.ruebarue.com/notification-tone.mp3",
);

const AppLoader = () => {
  console.log("Loading App");

  const { user, inbox, inboxes, refresh, loading } = useContext(
    AppContexts.AuthContext,
  );
  const { notification, getNotification, setNotification } = useContext(
    AppContexts.UtilContext,
  );

  const [socketInboxes, setSocketInboxes] = useState([]);

  useEffect(() => {
    refresh();
  }, []);

  const addSocketListeners = (conn) => {
    conn.addEventListener("open", (e) => {
      window.dispatchEvent(new Event("websocket-connect"));

      conn.addEventListener("close", (e) => {
        setSocketInboxes([]);
        addSocketListeners(
          new WebSocket(
            "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
          ),
        );
      });

      conn.addEventListener("message", (e) => {
        if (e.data === "") {
          return;
        }

        let message = JSON.parse(e.data);
        console.log("New Websocket Incoming", message);
        if (notification?.message_id !== message.message_id) {
          setNotification(message);
        }
      });

      // Join the room
      let inboxes = inbox.inboxes || [];
      if (inboxes.length > 0) {
        inboxes.map((ibx) => {
          if (socketInboxes.includes(ibx.id)) {
            return;
          }

          conn.send(
            JSON.stringify({
              service: "notifications",
              action: "join",
              data: {
                room: ibx.id,
              },
            }),
          );

          setSocketInboxes([...socketInboxes, ibx.id]);
        });
      }
    });
  };

  useEffect(() => {
    if (!inbox) {
      return;
    }

    addSocketListeners(
      new WebSocket(
        "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
      ),
    );
  }, [inbox]);

  // Old Notifications
  useEffect(() => {
    if (!!window.socket && !!inbox) {
      console.log("Joining", inbox.inbox_id);
      window.socket.emit("join", { inbox_id: inbox.inbox_id });
      window.socket.on("disconnect", () => {
        console.log("reconnecting");
        window.socket.emit("join", { inbox_id: inbox.inbox_id });
      });

      window.socket.on("incoming", (resp) => {
        getNotification(resp);
      });
    } else {
      window.addEventListener("socket-connect", () => {
        if (!!inbox) {
          window.socket.emit("join", { inbox_id: inbox.inbox_id });
          window.socket.on("disconnect", () => {
            window.socket.emit("join", { inbox_id: inbox.inbox_id });
          });

          window.socket.on("incoming", (resp) => {
            getNotification(resp);
          });
        }
      });
    }
  }, [inbox]);

  useEffect(() => {
    if (!!notification && window.Notification?.permission == "granted") {
      let silentTypes = ["automated", "user", "recipient"];
      if (!silentTypes.includes(notification.message_type)) {
        let note = new window.Notification(notification.headline, {
          body: notification.message_content,
          icon: "/images/logo.png",
        });

        tone.play();
      }
    }
  }, [notification]);

  useEffect(() => {
    // Expiremental. Trying to load custom components for UI Kit
    window.UIkit.component("ViewportBox", ViewportBox);
    window.UIkit.component("LineClamp", LineClamp);
  }, []);

  return (
    <>
      <Header />
      <Route
        path="/"
        render={(props) => (!loading ? <AppLayout {...props} /> : <Loading />)}
      />
      <Footer />
    </>
  );
};

export default AppLoader;
